import logoOnly from './images/logo-only.png';
import logo from './images/logo.png';

export const images = {
  logo,
  logoOnly,
};

export const files = {};
